const PREFIX = 'clubRegistration:';

export const isRecoveringRegistration = (progress) => Boolean(
  progress?.clubId || ['creating', 'uncertain'].includes(progress?.phase),
);

export const readRegistrationProgress = (uid, storage = localStorage) => {
  if (!uid) return null;
  try {
    const value = JSON.parse(storage.getItem(PREFIX + uid));
    return value?.version === 1 && value.uid === uid &&
      ['details', 'creating', 'uncertain', 'branding'].includes(value.phase) ? value : null;
  } catch (_) { return null; }
};

export const saveRegistrationProgress = (uid, value, storage = localStorage) => {
  const progress = { ...value, version: 1, uid };
  storage.setItem(PREFIX + uid, JSON.stringify(progress));
  return progress;
};

export const clearRegistrationProgress = (uid, storage = localStorage) => storage.removeItem(PREFIX + uid);
